export default __webpack_public_path__ + "static/covington-cf8df8de17a0426e405da2d7a7d56c3e.jpg";